module.exports = __webpack_public_path__ + "static/media/windscreen_broken.398d0541.svg";